module.exports = __webpack_public_path__ + "static/2-edc066542eb6bd9a64f62a703a299468.png";